import { createFileRoute } from "@tanstack/react-router"
import PMRegularVariantsTab from "~/components/product-management/tabs/RegularVariantsTab"
import { usePageTracking } from "../../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/active")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management Active")
  return <PMRegularVariantsTab />
}
